import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { defaultSuccess } from "../../../libs/utils";
import ListView from "../../../base/ListView";
import { toImmutable } from "../../../libs/immutable-transformer";
import { createToken, getTokens } from "../../../services/api/tokens";
import TokenForm from "../../forms/TokenForm";

class Tokens extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tokens: [],
      tokensMeta: {},
      tokensFilters: toImmutable({})
    };

    this._getTokens = this._getTokens.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    prop: PropTypes.string
  };

  UNSAFE_componentWillMount() {
    getTokens().then(response => {
      this.setState({
        tokens: response.data,
        tokensMeta: response.meta
      });
    });
  }

  _handleFilterUpdate(filter) {
    this._getTokens(filter);
  }

  _getTokens(filters = this.state.tokensFilters, notify = false) {
    getTokens(filters).then(response => {
      this.setState({
        tokens: response.data,
        tokensMeta: response.meta,
        tokensFilters: filters
      });

      if (notify) {
        defaultSuccess("Reloaded");
      }
    });
  }

  _handleSubmit(values) {
    createToken(values).then(response => {
      defaultSuccess("token generated, see console...");
      // eslint-disable-next-line no-console
      console.log(response);
    });
  }

  render() {
    const { tokens, tokensMeta, tokensFilters } = this.state;

    const listViewConf = {
      dataSet: tokens,
      dataMeta: tokensMeta,
      columns: [
        {
          key: "name",
          value: "name"
        },
        {
          key: "id",
          value: "Token"
        }
      ],
      baseFilters: tokensFilters,
      filters: [],
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/tokens"
    };

    return (
      <div>
        <AdminSubHeader title="Tokens">
          <button
            onClick={() => this._getJobs(undefined, true)}
            className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
          >
            <i className="la la-refresh" />
          </button>
        </AdminSubHeader>
        <div className="m-content" key="content">
          <div className="row">
            <div className="col-lg-8">
              <ListView
                config={listViewConf}
                handleFilterUpdate={this._handleFilterUpdate}
              />
            </div>
            <div className="col-lg-4">
              <div className="m-portlet">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <span className="m-portlet__head-icon">
                        <i className="flaticon-map-location" />
                      </span>
                      <h3 className="m-portlet__head-text">Create New Token</h3>
                    </div>
                  </div>
                </div>
                <TokenForm onSubmit={this._handleSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tokens;
